// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AccountDeleteModal_wrapper__yO045","title":"AccountDeleteModal_title__q0bI_","btn":"AccountDeleteModal_btn__HFDLo"};